import isUndefined from 'lodash/isUndefined';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import identity from 'lodash/identity';
import toPairs from 'lodash/toPairs';
import axios from 'axios';

const $config = {
	baseURL: '',
	headers: {
	}
};

const callbacks = {
	onSuccess: identity,
	onError: identity
};

const _serializeParameters = function (params) {
	if (isUndefined(params) || !isObject(params) || isArray(params) || isEmpty(params)) {
		return '';
	}

	const serialized = toPairs(params).map((pair) => {
		pair[1] = encodeURI(pair[1]);
		return pair.join('=');
	}).join('&');

	return serialized ? `?${serialized}` : '';
};

const get = function (url, params) {
	return axios.get(`${url}${_serializeParameters(params)}`, $config).then(callbacks.onSuccess, callbacks.onError);
};

const post = function (url, data) {
	return axios.post(url, data, $config).then(callbacks.onSuccess, callbacks.onError);
};

const put = function (url, data) {
	return axios.put(url, data, $config).then(callbacks.onSuccess, callbacks.onError);
};

const del = function (url, params) {
	return axios.delete(`${url}${_serializeParameters(params)}`, $config).then(callbacks.onSuccess, callbacks.onError);
};

const head = function (url, params) {
	return axios.head(`${url}${_serializeParameters(params)}`, $config).then(callbacks.onSuccess, callbacks.onError);
};

const options = function (url, params) {
	return axios.options(`${url}${_serializeParameters(params)}`, $config).then(callbacks.onSuccess, callbacks.onError);
};

const patch = function (url, data) {
	return axios.patch(url, data, $config).then(callbacks.onSuccess, callbacks.onError);
};

const url = function (url, queryStringParams = {}) {
	return `${$config.baseURL}${url}${_serializeParameters(queryStringParams)}`;
};

export default {
	get,
	post,
	put,
	del,
	delete: del,
	head,
	options,
	patch,
	all: Promise.all,
	url,
	callbacks,
	$config
};

export {
	get,
	post,
	put,
	del,
	head,
	options,
	patch,
	url
};
